<ppl-two-factor-method-setup-common
  title="Phone Number Verification"
  i18n-title="@@Phone_Number_Verification"
  [step]="step"
  [methodType]="TwoFAType.SMS"
  [securityToken]="securityToken"
  [getSetupData]="getSetupData"
  [actionDisabled]="actionDisabled"
  (nextStep)="onNextStep($event)"
  (cancel)="onCancel()"
  (finish)="onFinish($event)"
  [formGroup]="form">
  <ppl-two-factor-method-setup-step
    title="Setup your phone..."
    i18n-title="@@Setup_your_phone..."
    description="We will send you a verification code to authenticate for future logins."
    i18n-description="@@We_will_send_you_a_verification_code_to_authenticate_for_future_logins."
    infoMessage="Coevera CRM will only use this number for your account security"
    i18n-infoMessage="@@Coevera_CRM_will_only_use_this_number_for_your_account_security">
    <ppl-input-container
      label="Enter the phone number"
      i18n-label="@@Enter_the_phone_number"
      [bold]="true"
      pplFormControlName="phoneNumber">
      <ppl-input-phone-number formControlName="phoneNumber"></ppl-input-phone-number>
    </ppl-input-container>
  </ppl-two-factor-method-setup-step>
</ppl-two-factor-method-setup-common>
